module.exports = __webpack_public_path__ + "img/3.c119a9e8.png";